import { Checkbox } from '@/components/ui/checkbox';
import { Badge } from '@/components/ui/badge';
import { formatCurrency } from '@/utils/formatters';

interface NewInvestorListItemProps {
  investorId: string;
  investorName: string;
  commitmentAmount: number;
  isSelected: boolean;
  onToggle: (investorId: string) => void;
}

export function NewInvestorListItem({
  investorId,
  investorName,
  commitmentAmount,
  isSelected,
  onToggle,
}: NewInvestorListItemProps) {
  return (
    <div className="p-4 flex items-center justify-between hover:bg-muted/50 transition-colors">
      <div className="flex items-center gap-3">
        <Checkbox
          checked={isSelected}
          onCheckedChange={() => onToggle(investorId)}
        />
        <div>
          <p className="font-medium">{investorName}</p>
          <p className="text-sm text-muted-foreground">
            Commitment: {formatCurrency(commitmentAmount)}
          </p>
        </div>
      </div>
    </div>
  );
}

interface ExistingInvestorListItemProps {
  investorName: string;
  commitmentAmount: number;
  drawdownAmount: number;
  batchName: string;
}

export function ExistingInvestorListItem({
  investorName,
  commitmentAmount,
  drawdownAmount,
  batchName,
}: ExistingInvestorListItemProps) {
  return (
    <div className="p-4 flex items-center justify-between bg-muted/20">
      <div>
        <p className="font-medium">{investorName}</p>
        <div className="flex gap-4 text-sm text-muted-foreground mt-1">
          <span>Commitment: {formatCurrency(commitmentAmount)}</span>
          <span>Drawdown: {formatCurrency(drawdownAmount)}</span>
        </div>
      </div>
      <Badge variant="outline">{batchName}</Badge>
    </div>
  );
}
